/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：344
 */

"use strict"

export { Transparent as a }
export { o as b }
var /* [auto-meaningful-name] */Transparent = "transparent"
var o = [Transparent, "#FFFCF5FF", "#FFFEF0FF", "#EDFFEDFF", "#F2FFFCFF", "#F7FAFFFF", "#FAF8FFFF", "#FFF5F9FF", "#FFF6F5FF", "#FFFFFFFF", "#FFF7E8FF", "#FFFCDCFF", "#E2FFE2FF", "#DDFFF7FF", "#E8F2FFFF", "#EFEBF7FF", "#FCEEF3FF", "#FFF3F2FF", "#F5F5F7FF", "#FBE2BBFF", "#FFF6B9FF", "#B9FFBFFF", "#C9F6ECFF", "#B7DDFBFF", "#D4C7EEFF", "#F4B8CCFF", "#F1B9BAFF", "#CACACAFF", "#FFB445FF", "#FFEE53FF", "#83EC8CFF", "#46EED0FF", "#72BFFFFF", "#B6A3FFFF", "#FA8CBCFF", "#FF8B8BFF", "#7C7C7CFF", "#FC8C04FF", "#FADB14FF", "#37E547FF", "#11D5B1FF", "#2699FFFF", "#9179EAFF", "#F6669BFF", "#FD6060FF", "#383838FF", "#D36913FF", "#FFBE25FF", "#1BC514FF", "#1EAC91FF", "#196FF2FF", "#7659E5FF", "#D7487DFF", "#F14952FF"]
export default Transparent
